export interface IPageModel {
  pageNumber: number;
  itemsPerPage: number;
  totalItems: number;
  startItemNumber: number;
  totalPages: number;
}
export class PageModel implements IPageModel {
  constructor(
    public pageNumber: number,
    public itemsPerPage: number,
    public totalItems: number,
    public startItemNumber: number,
    public totalPages: number,
  ) { }
}


export interface ISearchResultModel extends IPageModel {
  filters: FilterResponse[];
  items: any[];
}
export class SearchResultModel extends PageModel implements ISearchResultModel {
  constructor(
    public pageNumber: number,
    public itemsPerPage: number,
    public totalItems: number,
    public startItemNumber: number,
    public totalPages: number,

    public filters: any[],
    public items: any[]
  ) {
    super(
      pageNumber,
      itemsPerPage,
      totalItems,
      startItemNumber,
      totalPages
    )
  }
}


export interface IFilterResponse {
  name: string;
  type: string;   // It is enum as a string // ToDo V use enum FilterType       // MultiSelect = 0, RadioSelect = 1, RangeNumber = 2, SingleBoolean = 3
  state: string;  // It is enum             // ToDo V use enum FilterStateType  // CollapsableClosed = 0, CollapsableOpened = 1, AlwaysOpen = 2
  custom?: ICustomRangeFilter;
  selectedDisplayName: string;
  selected?: string[];
  values: IDerivativeFilter[];
}
export class FilterResponse implements IFilterResponse {
  constructor(
    public name: string,
    public type: string,
    public state: string,
    public custom: CustomRangeFilter,
    public selectedDisplayName: string,
    public selected: string[],
    public values: DerivativeFilter[]
  ) { }
}

export interface ICustomRangeFilter {
  displayName: string;
  min: IValueRangeFilter;
  max: IValueRangeFilter;
}
export class CustomRangeFilter implements ICustomRangeFilter {
  constructor(
    public displayName: string,
    public min: ValueRangeFilter,
    public max: ValueRangeFilter,
  ) { }
}

export interface IValueRangeFilter {
  value: number;
  selected?: number;
}
export class ValueRangeFilter implements IValueRangeFilter {
  constructor(
    public value: number,
    public selected: number,
  ) { }
}


export interface IDerivativeFilter {
  displayName?: string;
  name?: string;
  count?: number;
}
export class DerivativeFilter implements IDerivativeFilter {
  constructor(
    public displayName: string,
    public name: string,
    public count: number,
  ) { }
}
